import { InformationCircleIcon } from '@heroicons/react/24/solid'

function InfoGraphic({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex items-center gap-2">
      <InformationCircleIcon className="text-ion-color-secondary size-5 flex-shrink-0" />
      <p className="italic leading-none">{children}</p>
    </div>
  )
}

export { InfoGraphic }
